export default "__VITE_ASSET__BQAv$G3t__"